<template>
  <div class="content contentTerms" :class="theme==0?'dark':'white'">
    <div class="mainDiv">
      <article class="main">
        <section class="topTitle">
          <img src="/static/img/work/argreementLogo.png" alt="">
          薄盒支付服务协议
        </section>
        <section class="intro bold">
          <h4 style="margin-bottom: 5px;text-align:right">版本号：2022 1版</h4>
          <p style="word-break: break-all;">
            感谢您选择薄盒支付快捷服务（以下称“本服务”），《薄盒支付服务协议》（以下称“本协议”）由北京擘盒科技有限公司（以下简称“本公司”）和使用本服务的用户（以下称“您”）签订。</p>
        </section>
        <section class="privacy-content">
          <ul>
            <li>
              <div class="rt">
                <p class="bold">1.协议的确认</p>
                <ul>
                  <li>
                    <div class="rt">
                      <p>1.1  请您先仔细阅读本协议内容，尤其是<span
                          class="bold">字体加粗部分（包括但不限于免除或限制本公司的责任、限制您的权利、规定争议解决方式和法律使用的相关条款）</span>。如您对本协议内容或页面提示信息有疑问，请不要进行后续操作。您可通过官方热线4009693319进行咨询，以便本公司为您解释和说明。
                      </p>
                      <p>1.2 <span
                          class="bold">您通过网络页面点击确认或以其他方式（包括但不限于签字或签章确认等方式）接受本协议或开通、使用本服务，即表示您与本公司已达成协议并同意接受本协议及附属协议的全部约定内容。</span>
                      </p>
                      <p>1.3 如您为无民事行为能力人或为限制民事行为能力人，请告知您的监护人，在您监护人的指导下阅读本协议，<span
                          class="bold">并在取得您监护人同意的前提下使用本服务。</span></p>
                      <p>
                        1.4
                        若您非中华人民共和国境内（为本协议之目的，不包括香港、澳门特别行政区及台湾地区）用户，且您所属的国家或地区排除本协议的全部或部分内容，则您应立即停止使用本服务，否则视为您自愿接受本协议全部约定。
                      </p>
                    </div>
                  </li>
                  <li>
                    <div class="rt">
                      <p class="bold">2. 相关定义</p>
                      <p>2.1 薄盒支付快捷服务：指本公司依托计算机信息系统为您提供的货币资金转移或其他授权服务，包括但不限于快捷支付服务、快捷绑卡实名认证，以及基于前述基础服务对应的增值服务等。</p>
                      <p>
                        2.2 快捷支付：指本公司及/或发卡行在事先或首笔交易时取得您绑卡签约授权后，向您指定银行账户的发卡行发起支付指令扣划资金的交易。绑卡模式包括但不限于快捷绑卡、一键绑卡（免输卡号绑卡）、发卡行APP/页面跳转绑卡等，以您实际选用模式为准。
                      </p>
                      <p>2.3 快捷绑卡实名认证：本公司为您提供的验证您的银行卡账号和您在发卡行预留的姓名、身份证件号的匹配性的服务。</p>
                      <p>2.4 指定银行账户：客户拟开通快捷支付服务的银行借记卡、贷记卡及其对应银行账户。</p>
                      <p>2.5 商户：您选择购买商品或服务的卖家，包括企业、事业单位或其他组织等。</p>
                      <p>2.6 平台账号：您在网银在线平台、商户自有平台或其合作的第三方平台开立的、您使用手机号或电子邮箱注册生成的会员账号，例如薄盒账号（PIN）。</p>
                      <p>2.7 本公司网站：除本协议另有规定外，指www.mintstech.cn及运营页面或客户端。</p>
                    </div>
                  </li>
                  <li>
                    <div class="rt">
                      <p class="bold">3. 快捷支付服务相关业务规则</p>
                      <p>3.1 快捷支付可支持业务场景主要包括消费、公共及便民服务、金融服务、支付账户服务、资金归集等。</p>
                      <p>3.2 您通过包括但不限于快捷绑卡等形式完成平台账号与指定银行账户的绑定后，您在本次或今后支付由本公司形成的交易订单并输入<span
                          class="bold">薄盒支付密码</span>，即视为您授权本公司向发卡行提交扣款指令，发卡行<span
                          class="bold">无需验证您的指定银行卡账户密码或网银盾</span>即可按照本公司传来的支付指令扣划您绑定的银行卡账户资金完成支付。基于保护您的合法权益及提高交易安全的目的，本公司或发卡行有权增加或变更上述身份识别要素进行校验或鉴权（如短信验证码、数字证书、<span
                          class="bold">人脸信息</span>等）。</p>
                      <p>3.3 <span
                          class="bold">快捷支付业务开通后，您不应以未在交易单据中签名、签名不符、非本人意愿交易、未验证银行卡支付密码、未验证银行卡支付盾等原因要求本公司或发卡行退款或承担其他责任。</span>
                      </p>
                      <p>3.4 <span
                          class="bold">您应在绑定银行账户中保留足够的余额，并保持银行账户处于正常状态。</span>因绑定银行账户余额不足、账户被冻结、销户等原因导致的无法成功支付费用及所造成的纠纷和违约责任、损失等法律后果由您自担。
                      </p>
                      <p>
                        3.5 您可通过发卡行的网上银行等渠道自助查询指定银行账户的快捷支付业务签约情况并对银行卡账户支付限额进行管理。
                        <span
                          class="bold">本公司可根据保障客户资金交易安全以及有效控制风险的原则，修改或调整快捷支付交易次数与交易金额限制、暂停或终止向特定用户提供快捷支付服务。任何情况下，您设置的支付限额不应超过发卡行及本公司设置的支付限额（以较低者为准），如实际支付金额大于支付限额，本公司有权拒绝执行交易指令。II类、III类银行账户受账户自身限额限制。</span>
                      </p>
                      <p>3.6 如本公司与发卡行快捷通道业务合作终止后，自终止之日起本协议自动失效。</p>
                      <p>3.7 一个平台账号可以绑定同一发卡行下的银行账户数量以发卡行规定或发卡行协议约定为准。</p>
                      <p>
                        3.8 如您需解绑银行卡或注销快捷支付业务，您可通过本公司端发起注销申请，本公司将注销申请传送给发卡行，发卡行同意并在银行系统中设置成功后完成注销。您也可通过发卡行的网上银行、手机银行主动发起解除快捷支付签约关系的申请。签约关系一旦解除，本协议即告终止。协议终止前已发送处理的交易指令仍有效。
                      </p>
                    </div>
                  </li>
                  <li>
                    <div class="rt">
                      <p class="bold">
                        3.8
                        如您需解绑银行卡或注销快捷支付业务，您可通过本公司端发起注销申请，本公司将注销申请传送给发卡行，发卡行同意并在银行系统中设置成功后完成注销。您也可通过发卡行的网上银行、手机银行主动发起解除快捷支付签约关系的申请。签约关系一旦解除，本协议即告终止。协议终止前已发送处理的交易指令仍有效。
                      </p>
                      <p>4.1
                        为了完成快捷支付服务的开通及使用（含解绑或停止使用本服务或银行卡销户/挂失/补办新卡等情况），防范风险，保障您的资金安全，您理解并同意本公司收集、存储、使用您自行填写或授权第三方提供的信息<span>与合作银行或合法留存您信息的第三方进行交叉验证及数据校验</span>。
                      </p>
                      <p>4.2 快捷绑卡业务模式下的个人信息处理授权：您同意并授权本公司在您首次使用快捷支付时收集您在<span
                          class="bold">本公司绑卡页面填写的或者您授权当前登录的第三方平台传输给本公司的姓名、身份证件类型及号码、银行卡号、银行预留手机号</span>等要素，传输给您的发卡行；发卡行匹配比对前述信息与您在银行预留信息一致后，您同意并授权发卡行向本公司返回验证结果，并在您的银行账号与支付账号、当前平台账号之间建立绑定支付关系。
                      </p>
                      <p>4.3 一键绑卡（免输卡号绑卡）业务模式下的个人信息处理授权：您在<span
                          class="bold">本公司绑卡页面</span>选择某家银行后，可跳转至发卡行提供的H5页面，您同意并授权本公司将您当前登录的平台账号对应的<span
                          class="bold">实名信息（姓名、身份证件号码、手机号码）</span>传输至该发卡行，以便您的发卡行在其服务页面向您展示您本人在该银行可用于开通快捷支付服务的银行卡列表。部分发卡行可能会要求您通过银行预留手机号码验证后方可查看银行卡列表，具体以发卡行业务为准。您在发卡行页面选择银行卡并签约后，您同意并授权发卡行将您选择的银行卡信息<span
                          class="bold">传输至该发卡行，以便您的发卡行在其服务页面向您展示您本人在该银行可用于开通快捷支付服务的银行卡列表。部分发卡行可能会要求您通过银行预留手机号码验证后方可查看银行卡列表，具体以发卡行业务为准。您在发卡行页面选择银行卡并签约后，您同意并授权发卡行将您选择的银行卡信息</span>传输至本公司，以便本公司根据发卡行提供的信息与平台账号相关信息进行匹配，识别对应的平台账号并建立快捷签约关系。本公司和发卡行对信息进行校验通过后跳回本公司绑卡页面并脱敏展示绑卡信息。
                      </p>
                      <p>4.4 发卡行APP/页面跳转绑卡业务模式下的个人信息授权：您在<span
                          class="bold">发卡行手机银行APP/H5页面</span>等场景选择要授权绑定薄盒支付的银行卡号，经您确认并授权后，发卡行APP/H5页面唤醒薄盒APP进入薄盒支付绑卡页面，并将用户银行卡信息
                        <span
                          class="bold">（姓名、身份证件类型及号码、银行卡号、银行预留手机号）</span>加密传输至本公司，本公司通过银行预留手机号码短信验证您的身份，并将发卡行提供的信息与平台账号相关信息进行比对验证，识别对应的平台账号并建立快捷签约关系。和发卡行对信息进行校验通过后跳回本公司绑卡页面并脱敏展示绑卡信息。
                      </p>
                      <p>4.5 快捷绑卡实名认证服务：为保障交易安全并履行反洗钱义务要求，本公司有权在绑卡签约环节前，<span
                          class="bold">先验证您当前平台账号的实名状态以便识别您的身份</span>。如果您输入的银行卡账号与您在银行的预留信息一致，则实名认证通过。
                        <span
                          class="bold">您的平台账号未实名或实名与绑卡信息比对不一致的情形下实名认证不通过，您将无法开通或继续使用本服务，且本公司有权通知当前平台采取措施予以处理或终止向问题账号继续提供服务，除非您重新进行实名认证或法律法规另有规定。为便于您便捷实名并确保您可正常开通快捷支付，您同意本公司将绑卡实名认证结果同步给当前平台进行关联或新建平台账号</span>。您授权并同意本公司在对您的平台账号进行实名认证后，记录并保存经过认证的银行卡信息<span
                          class="bold">（姓名、身份证件类型及号码、银行卡号、银行预留手机号）</span>，并自动对您平台账号下绑定的银行卡进行实名认证操作。
                      </p>
                      <p>4.6 为了及时、准确地完成付款，并满足反洗钱等监管要求，您理解并同意本公司需要记录您使用快捷支付服务的平台账号<span
                          class="bold">实名认证信息、银行卡信息、交易信息。在您使用本服务期间及本服务终止后，您理解并同意本公司在相关法律法规或监管要求的期限内留存您在使用本服务过程中产生的相关数据。</span>
                      </p>
                      <p>4.7 <span class="bold">您知悉并授权本公司将您已绑定的银行卡卡号、卡类型汇总并脱敏展示在本公司卡中心列表，并与您的平台账号关联。</span></p>
                      <p>4.8 <span
                          class="bold">为了向您提供更多的增值优惠服务，本公司可能会与银行、卡组织、薄盒关联公司或创作家联合向您提供支付优惠服务或者推送商品/支付优惠服务相关的消息或通知，如首次签约支付优惠、快捷支付优惠立减、满减、积分兑换、积分抵现等，您同意授权本公司根据您的绑卡时间、使用活跃度、积分情况、支付订单信息等进行优惠活动推荐。本公司保证该等信息仅用于薄盒业务场景下向您提供相关营销服务或对账目的，不会向任何第三方透露或允许第三方使用。您支付时主动选择使用有优惠券的银行卡，即视为您同意授权参加该银行与薄盒的联合营销活动。如您不同意参与以上活动，您可选择退订[根据《个人信息保护法》，应当同时提供不针对其个人特征的选项，或者向个人提供便捷的拒绝方式，故建议贵司在APP中的适当位置，设置拒绝相关推送的选项。]或联系我们客服电话反馈。</span>
                      </p>
                      <p>4.9 为防控交易风险，或在您选择提高或调整支付限额，及保证本电子合同的有效性的场景下，<span
                          class="bold">您同意并授权本公司将您的实名信息（姓名、手机号或电子邮箱）提供给数字证书服务机构用于为您生成合法有效的数字证书或电子签章。</span>数字证书到期后您应重新申请。本公司仅提供信息传输的技术服务，不对您与数字证书服务机构行为的合法性、有效性及数字证书服务的真实性、合法性和有效性作任何明示和默示的担保。数字证书服务机构应对其数字证书服务的合法性、准确性、完整性、安全性等承担完全独立责任。<span
                          class="bold">您享有数字证书的所有权，同时，因使用数字证书产生的义务、责任由您自行承担。</span></p>
                      <p>4.10 在合法合规且按照法律法规及国家标准的要求获得您授权的前提下，本公司基于开展实际业务的需要，可以将您的必要信息共享给业务合作必要的第三方。
                        <span
                          style="color:red">本公司如共享您的个人信息，或您需要我们将您的个人信息共享或转让至本公司外的第三方情形时，本公司会直接征得或确认第三方征得您对上述行为的明示同意，但法律法规另有规定除外。</span>本公司如共享您的个人信息，或您需要我们将您的个人信息共享或转让至本公司外的第三方情形时，本公司会直接征得或确认第三方征得您对上述行为的明示同意，但法律法规另有规定除外。
                      </p>
                      <p>4.11
                        本公司仅在实现前述约定目的，且在国家法律法规及监管政策允许的范围内使用您的前述信息。如您不同意向本公司准确、完整提供前述信息，本公司将无法提供绑卡实名认证、快捷支付服务或功能，但不影响您使用其他服务。
                      </p>
                      <p>
                        4.12 当本公司要将您的前述个人信息用于本协议未载明的其它用途时，会事先征求您的明示同意。请您理解，本公司向您提供的产品与/或服务将不断更新变化。如果您选择使用本协议中尚未列明的其他产品与/或服务时，在本公司收集您的个人信息前，本公司会通过业务协议、页面提示的方式向您详细说明信息收集的目的、方式、范围并征求您的明确同意。
                      </p>

                    </div>
                  </li>
                  <li>
                    <div class="rt">
                      <p class="bold">5. 您的权利和义务</p>
                      <p>5.1 您自愿申请开通本服务，并有权办理相关资料和信息变更、业务暂停、恢复和注销手续。如您对本服务有疑问、建议或意见，有权致电本公司或发卡行官方网站、营业网点咨询。</p>
                      <p>
                        5.2 您应确保开通本服务所提供的信息为本人所有，并授权本公司可以通过合法持有您信息的第三方渠道对您所提供信息的真实性、有效性进行核实，且您是使用本服务的银行卡持有人，可合法、有效使用该银行卡且未侵犯任何第三方合法权益，否则因此造成本公司、持卡人损失的，您应负责赔偿并承担法律责任。
                      </p>
                      <p>5.3 您在使用本服务时，应当认真确认交易信息，包括且不限于商品名称、数量、金额等，输入薄盒支付密码或校验码进行支付。<span
                          class="bold">您认可和同意：您对发出指令的真实性及有效性承担全部责任，且您发出的指令不可撤回或撤销，本公司一旦根据您的指令委托银行或第三方从银行卡中划扣资金给收款人，您不应以非本人意愿交易或其他任何原因要求本公司退款或承担其他责任。</span>
                      </p>
                      <p>5.4 <span
                          class="bold">您使用快捷支付购买的商品或服务的范围仅限于实名制服务或实物类商品，并具备可追溯条件。您不得利用快捷支付业务进行套现、虚假交易、洗钱等违法行为，有义务配合本公司或发卡行进行相关调查。如您拒绝配合进行相关调查或本公司认为存在虚假交易、洗钱、套现或任何其他非法活动、欺诈或违反诚信原则的行为、或违反本协议约定的，本公司有权依法暂停或终止提供快捷支付服务、终止本协议等，如因前述行为给本公司造成损失的，您应负责赔偿。</span>
                      </p>
                      <p>5.5 <span
                          class="bold">您同意本公司有权依据其自身判断对涉嫌欺诈或被他人控制并用于欺诈目的的薄盒支付相关交易及银行卡账户采取相应的措施，上述措施包括但不限于解除您的银行卡或手机号的绑定关系、冻结相应银行卡的支付、处置涉嫌欺诈的资金等。如您有异议的，需按页面提示验证身份或者可联系本公司客服进行申诉处理并提供相应证明材料。</span>
                      </p>
                      <p>5.6 <span
                          class="bold">您应妥善保管身份证件、银行卡、卡号、有效日期、卡背后三位数字、密码、发卡行预留的手机号码以及薄盒支付密码、数字证书、手机动态口令、绑定的手机号码、来自于发卡行和/或本公司向您发送的校验码等与银行卡或与薄盒支付服务有关的信息和设备。</span>此外您应采取风险防范措施，安全使用快捷支付业务，包括避免使用容易被猜出或具有规律性的数字或字母组合作为薄盒支付密码，应经常关注银行账户内资金变化等动账通知。<span
                          class="bold">如您遗失或泄露前述信息和/或设备的，您应及时通知发卡行及/或本公司，以减少可能发生的损失。无论是否已通知发卡行及/或本公司，因泄露密码、手机号、校验码、数字证书、丢失银行卡、Ukey等原因所致损失需由您自行承担。</span>
                      </p>
                      <p class="bold">6. 本公司的权利和义务</p>
                      <p>
                        6.1 本公司有权根据您的实名情况，决定是否开通快捷支付服务。当本公司有合理理由认为您提供的资料有误、不实、陈旧或不完善时，本公司有权暂停或终止向您提供部分或全部服务，除非您在指定期间内补齐相关证明材料或者重新完成实名认证。
                      </p>
                      <p>6.2 <span
                          class="bold">为控制可能存在的风险，本公司有权依法对您使用本服务进行交易的单笔限额、单日累计限额及单日最高次数等进行限制，并保留对限制银行卡种类和限制限额进行无需预告即调整的权利。</span>
                      </p>
                      <p>6.3 本服务的具体流程，可能因适用场景和功能存续情况的变化而发生调整，具体以本公司实际提供的服务流程为准。如您有疑问的，可随时终止使用或向我们反馈。</p>
                      <p>6.4 <span class="bold">您认可本服务的使用记录数据、交易金额数据等均以本公司系统平台记录的数据为准。</span></p>
                      <p>6.5 <span class="bold">出现下列情况之一的，本公司有权立即终止您使用本公司相关服务而无需承担任何责任：</span></p>
                      <p class="bold">（1）将本服务用于非法目的；</p>
                      <p class="bold">（2 违反本公司及/或本公司关联公司的网站的条款、协议、规则、通告等相关规定及您与前述主体签署的任一协议，而被上述任一主体终止提供服务的；</p>
                      <p class="bold">（3）本公司认为向您提供本服务存在风险的；</p>
                      <p class="bold">（4）您向本公司提供的个人信息已经失效或者未更新的；</p>
                      <p class="bold">（5）您未按本公司要求完成实名认证的；</p>
                      <p class="bold">（6）您的银行卡无效、有效期届满或注销（如有）。</p>
                      <p>6.6 <span
                          class="bold">若您未违反本协议约定且因不能归责于您的原因，造成银行卡内资金通过本服务出现损失，且您未从中获益的，您可向本公司申请补偿。</span>您应在知悉资金发生损失后及时通知本公司并按要求提交相关的申请材料和证明文件，本公司将通过自行补偿或保险公司赔偿的方式处理您的申请。具体处理方式由本公司自行选择决定，本公司承诺不会因此损害您的合法权益。如本公司选择保险赔偿的方式，您同意委托本公司为您向保险公司索赔，并且您承诺：资金损失事实真实存在，保险赔偿申请材料真实、有效。您已充分知晓并认识到，基于虚假信息申请保险赔偿将涉及刑事犯罪，保险公司与本公司有权向国家有关机关申请刑事立案侦查。
                      </p>
                      <p>
                        6.7 不论本公司选择何种方式保障您使用本服务的资金安全，您同意并认可本公司最终的补偿行为或保险赔偿行为并不代表前述资金损失应归责于本公司，亦不代表本公司须为此承担其他任何责任。<span
                          class="bold">您同意，本公司在向您支付补偿的同时，即刻取得您可能或确实存在的就前述资金损失而产生的对第三方的所有债权及其他权利，包括但不限于就上述债权向第三方追偿的权利，且您不再就上述已经让渡给本公司的债权向该第三方主张任何权利，亦不再就资金损失向本公司主张任何权利。</span>
                      </p>
                      <p>6.8
                        若您又从其它渠道挽回了资金损失的，或有证据证明您涉嫌欺诈的，或者发生您应当自行承担责任的其他情形，您应在第一时间通知本公司并将返还本公司已补偿或保险公司已赔偿的款项，否则本公司有权自行或根据保险公司委托采取包括但不限于从您全部或部分本公司账户（含该账户之关联账户）划扣等方式向您进行追偿。
                      </p>
                      <p>6.9
                        本服务开通后，支付交易经清算机构转发并置为终态后，即具有最终性，以清算机构联机交易结果为准进行资金划付处理。但资金划付结果不代表合作商户提供的商品及服务质量、物流结果、权益落实等相关信息，本公司对商品及服务的质量、物流状态等不负有任何责任。<span
                          class="bold">因该等商品及服务的质量、物流及权益落实等原因产生的纠纷由您与合作商户或其他第三方自行解决，与本公司无关，本公司不承担连带责任。</span></p>
                      <p class="bold">7. 服务费用</p>
                      <p class="bold">
                        您理解，本服务存在营运成本，为了持续营运，本公司有权向您收取服务费用，服务费用的收取方式以您在使用本服务时收到的各类通知、告知、公告生效之日起实施。本公司发出的有关收费的各类通知、告知均为本协议的组成部分，您若在有关收费的各类通知或告知生效后仍然使用本服务，则视为您同意按照相关通知、告知所约定的收费标准和收费条件向本公司支付服务费用。<span
                          class="bold">除非另有说明或约定，您同意本公司有权自您委托本公司代为收取或代为支付的款项或者其他资产中直接扣除上述服务费用。</span></p>
                      <p class="bold">8. 知识产权保护</p>
                      <p>
                        8.1 本公司在本服务中提供的内容（包括但不限于著作、图片、档案、咨询、音频、视频、图表、网站架构、网站画面安排、网页设计等）均由本公司或关联公司拥有知识产权，包括但不限于商标权、专利权、著作权、商业秘密等。
                      </p>
                      <p>8.2 除另有特别声明外，本公司提供本服务时所依托软件的著作权、专利权及其他知识产权均归本公司及其关联公司所有。</p>
                      <p>8.3 本公司在本服务中所使用的“薄盒支付”商业标识，其著作权或商标权归本公司及其关联公司所有。</p>
                      <p>8.4 上述知识产权均受到法律保护，未经本公司、你或相关权利人书面许可，任何人不得以任何形式擅自使用、修改、反向编译、复制、公开传播、改变、散布、发行或创造相关衍生作品。</p>
                      <p class="bold">9. 法律适用和管辖</p>
                      <p>9.1 您同意，本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律，没有相关法律规定的，参照通用国际商业惯例和（或）行业惯例。</p>
                      <p>9.2 <span
                          class="bold">您同意，因本协议产生之争议，双方应努力友好协商解决。如协商不成，本公司和您同意由本协议签订地（北京市朝阳区）法院管辖审理双方的纠纷或争议。</span>
                      </p>
                      <p class="bold">10. 其他</p>
                      <p>
                        10.1 因不可抗力（包括但不限于不能预见、不能避免并不能克服的战争、暴动、自然灾害、政府行为、社会事件、黑客攻击、供电、通讯运营商或网络故障等客观情况）等因素导致本公司快捷支付业务中断或处于不稳定状态，本公司已尽力采取补救措施但仍未能避免损失的情况下，不承担相关责任。
                      </p>
                      <p>10.2 因国家法律法规变化、市场发展等情况，本公司可能会对本协议内容进行变更，并将在网站（https://www.mintstech.cn/)等显著位置<span
                          class="bold">以公告的方式提前30日予以公布。修订后的协议生效日期以公告载明日期为准</span>。公告期间内，如您对协议有任何疑问或意见的，可向本公司客服咨询或反馈。如您不同意本协议修订内容，您可以停止使用本服务。<span
                          class="bold">如公告期满，您未提出异议且仍继续使用本服务的，视为您默认接受本协议全部内容。</span>双方协商一致的，也可另行签署相关书面协议。</p>
                      <p>10.3 本协议部分内容被有管辖权的法院认定为违法或无效的，不因此影响其他内容的效力。</p>
                      <p>
                        10.4 您通过互联网（Internet）点击确认或勾选方式选择接受本协议，视为同意并签署本协议，并承担由此产生的责任。快捷支付业务自完成首笔验证、薄盒账号或平台账号与指定银行账户完成绑定后生效。
                      </p>
                      <p>10.5 本协议未尽事宜将由本公司不时补充、制订的规定。如本协议与其他既有协议就本服务同一事项的约定冲突的，应以本协议为准。</p>
                      <p class="bold">
                        您确认已仔细阅读了本协议，并特别注意了字体加黑的条款，对本协议条款的含义及相应的法律后果已全部知晓并充分理解，愿意遵守其全部内容；本公司已应要求对相关条款进行了充分的提示和说明。</p>
                    </div>
                  </li>
                </ul>
              </div>
            </li>




















          </ul>
        </section>
      </article>

    </div>
  </div>
</template>
<script>
  export default {
    name: "bankAgreement",
    data() {
      return {
        theme: 0,
      }
    },
    mounted() {
      window.scrollTo(0, 0);
      if (this.$route.query.theme) {
        this.theme = this.$route.query.theme
        console.log(this.theme)
      }
    }
  }

</script>

<style scoped="scoped" lang="less">
  .main {
    overflow: hidden;
    background-color: #0C0C0C;
    margin: 34px 16px;
    // box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    margin-bottom: 40px;
    font-size: 14px;
    color: #8d8f9f;
    line-height: 1.75;
    text-align: left;
  }

  .contentTerms {
    // background: #0C0C0C;
  }

  * {
    margin: 0;
    padding: 0;
  }

  a {
    word-break: break-all;
  }

  a:link {
    color: #5bb6fa;
  }

  /* 未被访问的链接 */
  a:visited {
    color: #935171;
  }

  /* 已被访问的链接 */
  a:hover {
    text-transform: uppercase;
  }

  /* 鼠标指针移动到链接上 */
  /* a:active {background:#FF704D;}  正在被点击的链接 */

  li {
    list-style: none;
  }

  .content {
    /* padding-top: 56px; */
  }

  .intro {
    color: #BDBDBD;
    font-size: 12px;
  }

  .topTitle {
    color: #f5f4f9;
    font-size: 17px;
    font-weight: bold;
    text-align: center;
    display: inline-block;
    margin-bottom: 17px;
  }

  .topTitle img {
    width: 47px;
    height: 47px;
    object-fit: cover;
    display: inline-block;
    vertical-align: middle;
  }

  .content {
    /* position: absolute;
    top: 15px;
    right: 16px;
    left: 16px;
    bottom: 0;
    background-color: #0C0C0C;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.5);
    border-radius: 4px; */
  }

  .mainDiv {
    /* position: absolute;
    top: 15px;
    right: 0;
    left: 0;
    bottom: 15px;
    overflow-y: scroll;
    padding: 15px 15px 0 15px;
    box-sizing: border-box;
    text-align: left; */

    padding: 10px;
    font-size: 14px;
    color: #8d8f9f;
    line-height: 1.75;
  }

  .main {}

  .privacy-content {
    color: #83878B;
    font-size: 12px;
  }

  .privacy-content ul li {
    /* display: flex;
    align-items: flex-start; */
  }

  .privacy-content>ul>li {}

  .privacy-content ul li .lf {
    text-align: right;
  }

  .privacy-content ul li .rt {
    text-align: left;
  }

  .privacy-content ul li p {}

  .privacy-content .desc {}

  .privacy-content .desc a {
    color: #83878b;
  }

  .bold {
    font-weight: bolder;
  }


  .dark {
    background: #000000;

    .main {
      padding: 10px;
      background-color: #0C0C0C;
      color: #8d8f9f;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.5);
    }

  }

  .white {
    background: #ffffff;

    .main {
      padding: 10px;
      background-color: #f1f1f1;
      color: #333333;
      box-shadow: 0px 1px 2px 0px rgba(226, 226, 226, 0.5);
    }

  }

</style>



// WEBPACK FOOTER //
// src/views/bankAgreement.vue